module.exports = __webpack_public_path__ + "static/img/banner02.dfe32ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/banner02.png
// module id = PWQV
// module chunks = 1